// extracted by mini-css-extract-plugin
export default {"dialog":"SuccessInfoDialog_dialog__19R6h","icon":"SuccessInfoDialog_icon__g1-zv","formButton":"SuccessInfoDialog_formButton__B-Wiq"};